import React, { createContext, useCallback, useContext, useState } from "react";
import AtestModal from "./AtestModal";

const AtestContext = createContext({ open: () => {} });

export function AtestProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return (
    <AtestContext.Provider value={{ open }}>
      {children}
      <AtestModal open={isOpen} onClose={close} />
    </AtestContext.Provider>
  );
}

export function useAtest() {
  return useContext(AtestContext);
}
